import React from "react";

const darkcolors = ["Red", "Black"]
export default function TitleSegment({ segment }) {
  return (
    <div className="titleSegment" style={{ backgroundColor: segment.segstyle?.bg.value, padding: "50px 0" }}>
      <div className="text-center">
        <h1 style={{ color: darkcolors.includes(segment.segstyle?.bg.title) ? "#FFF" : "#000" }}>{segment.title}</h1>
        <p style={{ color: darkcolors.includes(segment.segstyle?.bg.title) ? "#FFF" : "#000" }}>{segment.description}</p>
      </div>
    </div>
  )
}